import hexToRgba from "hex-to-rgba";
import React, { useEffect, useState } from "react";
import { Text, Transformer } from "react-konva";
import { EnumAlign } from "../../Config/config";
import helper_functions from "../../Config/helper_functions";

function TextComponent({
  // userSliceState,
  setActive,
  id,
  textProperties,
  isSelected,
  onSelect,
  differenceFactor, //difference between the size of main image and canvas
  //we need to add these points because we are using square canvas and there is some white space around image eihter in X or Y dimension and we dont want that in downloaded image. these are used in second canvas, in first they are just 1
  xPointsToAdd,
  yPointsToAdd,
  xCordsOfMainImage,
  yCordsOfMainImage,
  canvasImageHeight,
  canvasImageWidth,
  setTextProperties,
  active,
  onUnselect,
  canvasWidth,
  draggable,
}) {
  const textRef = React.useRef();
  const textTransformRef = React.useRef();
  const [xCords, setXCords] = useState(0);
  const [yCords, setYCords] = useState(0);
  const [containerHight, setContainerHight] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);
  const [properties, setProperties] = useState({});

  useEffect(() => {
    setTextProperties(properties);
  }, [properties]);

  useEffect(() => {
    var sizeOfContainer = parseFloat(
      Math.max(containerHight, containerWidth).toFixed(3)
    );

    setTextProperties({
      x: xCords,
      y: yCords,
      id: textProperties.id,
      alignEnable: textProperties.alignEnable,
      scaleX: textProperties.scaleX,
      scaleY: textProperties.scaleY,
      sizeOfContainer,
      containerHight,
      containerWidth,
    });
  }, [xCords, yCords]);

  useEffect(() => {
    setXCords(textProperties.x);
    setYCords(textProperties.y);
  }, []);

  useEffect(() => {
    if (textProperties.src) {
      textRef.current.cache();
      setContainerHight(textRef.current.height());
      setContainerWidth(textRef.current.width());
    }
  }, [textProperties]);

  useEffect(() => {
    // let xDifference = textProperties.x + xPointsToAdd;
    // let yDifference = textProperties.y - yPointsToAdd;
    // setXCords(xDifference * differenceFactor);
    // setYCords(yDifference * differenceFactor);

    if (isSelected) {
      textTransformRef.current.nodes([textRef.current]);
      textTransformRef.current.getLayer().batchDraw();
    }
  }, [
    isSelected,
    textProperties.x,
    textProperties.y,
    xPointsToAdd,
    yPointsToAdd,
  ]);

  useEffect(() => {
    //calculating the X and Y cordinates of logo image. as canvas size and image size is different and we want the logo to be on exect position as it was on canvas
    //because canvas size is different and there is some white space either vertically or horizontaly so elwe need to subtract those pixels and then multiply with the scale the main image was resized

    helper_functions.alignment(
      1,
      textProperties,
      textRef,
      helper_functions.degToRad,
      getCenterPoint,
      yCordsOfMainImage,
      xCordsOfMainImage,
      differenceFactor,
      canvasImageHeight,
      canvasImageWidth,
      setYCords,
      setXCords,
      helper_functions.newPoints
    );
  }, [
    textProperties.src,
    textProperties.alignEnable,
    canvasImageHeight,
    canvasImageWidth,
    differenceFactor,
    textProperties,
    xCordsOfMainImage,
    yCordsOfMainImage,
  ]);

  // KW: We shift then offset from top left to center for rotation. now we need to adjust x and y everywhere

  const getCenterPoint = () => {
    let width;
    let height;
    if (textRef.current) width = textRef.current.textWidth / 2;

    if (textRef.current) height = textRef.current.textHeight / 2;
    const centerPoint = {
      x: width,
      y: height,
    };

    return centerPoint;
  };

  useEffect(() => {
    if (textRef && textRef.current && containerWidth) {
      let scaleFactor = textRef.current.width();
      scaleFactor = canvasWidth / scaleFactor;
      var newScale = {
        scaleX: textProperties.scaleX,
        scaleY: textProperties.scaleY,
      };
      if (textProperties.scaleX === 0 && textProperties.scaleY === 0) {
        let scale = helper_functions.decryptToScaleAndSize(
          textProperties.width,
          canvasWidth,
          containerWidth
        );
        newScale = {
          scaleX: scale,
          scaleY: scale,
          // scaleFactor: (scaleFactor * 2),
        };
      }

      setTextProperties({
        ...textProperties,
        ...newScale,
        scaleFactor: scaleFactor * 2,
      });
    }
  }, [textRef, containerWidth]);

  return (
    <>
      <Text
        onClick={() => {
          if (active !== id) {
            onSelect(textProperties.id);
            setActive(textProperties.property);
            setTextProperties({
              x: textProperties.x,
              y: textProperties.y,
              id: textProperties.id,
              scaleX: textProperties.scaleX,
              scaleY: textProperties.scaleY,
            });
          } else {
            onUnselect();
            setActive("");
          }
        }}
        draggable={draggable}
        ref={textRef}
        x={xCords}
        y={yCords}
        fontSize={Math.max(
          Math.min(
            Math.floor((canvasWidth * 13) / textProperties.src.length),
            500
          ),
          100
        )}
        // fontSize={500}
        fontFamily={textProperties.font}
        rotation={textProperties.deg}
        offsetX={getCenterPoint().x}
        offsetY={getCenterPoint().y}
        scaleX={
          textProperties.scaleXSlide
            ? textProperties.scaleXSlide
            : textProperties.scaleX
        }
        scaleY={
          textProperties.scaleYSlide
            ? textProperties.scaleYSlide
            : textProperties.scaleY
        }
        opacity={textProperties.opacity}
        shadowColor={hexToRgba(textProperties.shadowColor)}
        shadowEnabled={textProperties.enableShadowColor}
        shadowOffsetX={-20}
        shadowOffsetY={20}
        shadowBlur={50}
        align={textProperties.textAlign}
        // wrap="word"
        // width={textWidth < canvasImageWidth ? null : canvasImageWidth*3}
        fill={hexToRgba(textProperties.textColor)}
        text={textProperties.src}
        onDragStart={(e) => {
          setActive(textProperties.property);
          onSelect(textProperties.id);
          setTextProperties({
            alignEnable: EnumAlign.None,
            id: textProperties.id,
            x: e.target.attrs.x,
            y: e.target.attrs.y,
            scaleX: e.target.attrs.scaleX,
            scaleY: e.target.attrs.scaleY,
          });
        }}
        onDragEnd={(e) => {
          setXCords(e.target.attrs.x);
          setYCords(e.target.attrs.y);
          setTextProperties({
            x: e.target.attrs.x,
            y: e.target.attrs.y,
            id: textProperties.id,
            scaleX: e.target.attrs.scaleX,
            scaleY: e.target.attrs.scaleY,
          });
        }}
        onTransform={(e) => {
          // const node = textRef.current;
          //KW: We shift then offset from top left to center for rotation. now we need to adjust x and y everywhere
          // setTimeout(() => {
          setProperties({
            ...textProperties,
            x: e.target.attrs.x,
            y: e.target.attrs.y,
            // deg: e.target.attrs.rotation, //deg is the angle of rotation
            scaleXTransform: parseFloat(e.target.attrs.scaleX.toFixed(2)),
            scaleYTransform: parseFloat(e.target.attrs.scaleY.toFixed(2)),
            id: textProperties.id,
            alignEnable: EnumAlign.None,
          });
          // }, 1000);
        }}
        onTransformEnd={(e) => {
          // const node = textRef.current;
          //KW: We shift then offset from top left to center for rotation. now we need to adjust x and y everywhere
          // setTimeout(() => {
          setProperties({
            x: e.target.attrs.x,
            y: e.target.attrs.y,
            deg: e.target.attrs.rotation, //deg is the angle of rotation
            scaleX: e.target.attrs.scaleX,
            scaleY: e.target.attrs.scaleX,
            id: textProperties.id,
            alignEnable: EnumAlign.None,
          });
          // }, 1000);
        }}
        globalCompositeOperation="source-over"
      />
      {/* Transformer is the konva component to control the dimensions of a konva element, here it is used on konva.text */}
      {isSelected && (
        <Transformer
          // boundBoxFunc={boundBoxFunc}
          ref={textTransformRef}
          rotateEnabled
          anchorFill="white"
          anchorStroke="black"
          anchorStrokeWidth={1}
          anchorSize={8}
          borderDash={[3, 3]}
          borderDashOffset={0}
          borderEnabled
          borderStroke="#F2526F"
          borderStrokeWidth={1}
          padding={0}
          anchorCornerRadius={4}
          rotateAnchorOffset={20}
          // keepRatio={true}
          enabledAnchors={[
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right",
          ]}
          flipEnabled={false}
        />
      )}
    </>
  );
}
export default TextComponent;
